import { createSlice } from '@reduxjs/toolkit';

const userStateSlice = createSlice({
    name: 'userState',
    initialState: {
        isAuthenticated: false,
        isLoading: true,
        isCaptchaEnabled: null,
        isCaptchaForSurveyEnabled: null
    },
    reducers: {
        setIsAuthenticated: (state, action) => {
            const {isAuthenticated, isLoading, isCaptchaEnabled, isCaptchaForSurveyEnabled} = action.payload;
            state.isAuthenticated = isAuthenticated;
            state.isLoading = isLoading;        
            state.isCaptchaEnabled = isCaptchaEnabled; 
            state.isCaptchaForSurveyEnabled = isCaptchaForSurveyEnabled;   
        },
    },
});

export const { setIsAuthenticated } = userStateSlice.actions;
export default userStateSlice.reducer;
